export const BOOKING_LIST_PAGE_SIZE = 25;

export const BOOKING_LIST_REQUEST = '@maia/Booking/BOOKING_LIST_REQUEST';
export const BOOKING_LIST_SUCCESS = '@maia/Booking/BOOKING_LIST_SUCCESS';
export const BOOKING_LIST_ERROR = '@maia/Booking/BOOKING_LIST_ERROR';
export const BOOKING_LIST_APPLY_CHANGE = '@maia/Booking/BOOKING_LIST_APPLY_CHANGE';
export const BOOKING_LIST_APPLY_FILTER = '@maia/Booking/BOOKING_LIST_APPLY_FILTER';
export const BOOKING_LIST_APPLY_SORT = '@maia/Booking/BOOKING_LIST_APPLY_SORT';
export const BOOKING_LIST_APPLY_PAGINATION = '@maia/Booking/BOOKING_LIST_APPLY_PAGINATION';
export const BOOKING_LIST_APPLY_SEARCH = '@maia/Booking/BOOKING_LIST_APPLY_SEARCH';
export const BOOKING_LIST_APPLY_RESET = '@maia/Booking/BOOKING_LIST_APPLY_RESET';

export const AUTH_USER_SUCCESS = '@maia/Booking/AUTH_USER_SUCCESS';
export const AUTH_USER_ERROR = '@maia/Booking/AUTH_USER_ERROR';

export const FLEET_BOOKING_SOURCES = [
  { key: 'indie_campers', text: 'Indie Campers', utmSource: 'indie_campers' },
  { key: 'uckg', text: 'UCKG', utmSource: 'uckg' },
  { key: 'rge', text: 'RGE', utmSource: 'rge' },
  { key: 'plantplan', text: 'Plant Plan', utmSource: 'plantplan' },
  { key: 'motovia', text: 'Motovia', utmSource: 'motovia' },
  { key: 'cavish', text: 'Cavish', utmSource: 'cavish' },
  { key: 'other_fleet', text: 'Other fleet', utmSource: 'other_fleet' },
];

export const UTM_SOURCES = ['call', ...FLEET_BOOKING_SOURCES.map(({ utmSource }) => utmSource)];
/**
 * Keep in sync with landing list of utm mediums
 * https://github.com/fxtr/landing-react/blob/master/src/server/util/readPromoCampaign/index.ts#L58
 */
export const UTM_MEDIUMS = ['sales', 'cs', 'fleets'];
export const UTM_CAMPAIGNS = ['new_booking', 'repeat_booking', 'warranty_booking', 'fleet_booking'];
